
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface PersonalityTestHistoryTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export default function PersonalityTestHistoryTabs({ activeTab, onTabChange }: PersonalityTestHistoryTabsProps) {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="mb-8">
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value="all">Todos os Testes</TabsTrigger>
        <TabsTrigger value="big-five">Big Five</TabsTrigger>
        <TabsTrigger value="young-schemas">Esquemas de Young</TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
